<template>
  <!-- OCRによる読み込み開始 -->
  <ModalDialog
    pop-name="OCRによる読み込み開始"
    dialog-height="auto"
    dialog-width="750px"
    margin-class="mbm-3 mtp-3"
    @close="closeModal"
  >
    <template #header> </template>

    <template #body>
      <div>
        <div class="d-flex mtp-3 col-12">
          <div class="col-1"></div>
          <div class="col-10">OCRによる読み込みを開始します。</div>
        </div>
        <div class="d-flex mtp-1 col-12">
          <div class="col-1"></div>
          <div class="col-10">
            ＊「キャンセル」ボタンを押下するとファイルの読み込みを中止。
          </div>
        </div>
        <div class="d-flex mtp-1 col-12">
          <div class="col-1"></div>
          <div class="col-10">
            ＊「OK」ボタンを押下するとダイアログが閉じられ、ファイルの読み込みを開始。
          </div>
        </div>
      </div>
    </template>

    <template #footer>
      <div class="d-flex justify-content-center">
        <ButtonMain button-name="OK" @click="NoOCRclose1"></ButtonMain>
        <ButtonNormal
          class="ms-4"
          button-name="キャンセル"
          @click="cancel"
        ></ButtonNormal>
      </div>
    </template>
  </ModalDialog>
</template>
<script>
export default {
  name: 'LoadingByOCRDialog',
  props: {},
  data() {
    return {}
  },
  methods: {
    closeModal() {
      this.$emit('close')
    },
    cancel() {
      this.$emit('ok')
    }
  }
}
</script>
<style scoped lang="scss"></style>
